
import {Component, Mixins, Prop, Ref, Watch} from "vue-property-decorator";
import Dates from "@/components/inputs/Dates.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import AlacakTuruPicker from "@/components/pickers/AlacakTuruPicker.vue";
import {AlacakBelgeTuru} from "@/enum/AlacakBelgeTuru";
import {ParaBirimi} from "@/enum/ParaBirimi";
import FormWrapper from "@/components/FormWrapper.vue";
import Faizler from "@/components/forms/Faizler.vue";
import ParaBirimiPicker from "@/components/pickers/ParaBirimiPicker.vue";
import {AlacakKalemiTuru} from "@/enum/AlacakKalemiTuru";
import {TakipTalebiEntity} from "@/entity/TakipTalebiEntity";
import {DovizTakipSekli} from "@/enum/DovizTakipSekli";
import Kur from "@/components/inputs/Kur.vue";
import {AlacakEntity} from "@/entity/AlacakBelgeler/AlacakEntity";
import {FaizTuruEntity} from "@/entity/FaizTuruEntity";

@Component({
  components: {
    Kur,
    ParaBirimiPicker,
    AlacakTuruPicker,
    FormWrapper,
    Tutar,
    Dates,
    Faizler,
  },
})
export default class SozlesmeAlacakKalemiForm extends Mixins(ObjectInputMixin) {
  @Prop() hideButtons!: boolean|string;
  @Prop() takipTipiId!: number;
  @Prop() alacak!: AlacakEntity;
  @Ref('form') readonly form!: FormWrapper;

  readonlyParaBirimi = false;
  paraBirimi = ParaBirimi;
  AlacakBelgeTuru = AlacakBelgeTuru;

  async save(){
    if (this.alacak.id){
      this.localValue.alacak_kalemi_alani_id = 1
      this.localValue.alacak_id = this.alacak.id

      if (this.alacak.alacak_belge_turu_id !== this.AlacakBelgeTuru.apartman_alacagi){
        this.localValue.gecikme_tazminati_mi = false
      }else{
        if (this.localValue.gecikme_tazminati_mi){
          this.localValue.gecikme_tazminati_mi = true
        }else{
          this.localValue.gecikme_tazminati_mi = false
        }
      }

      if (this.localValue.id){
        if (this.localValue.elle_faiz_oran_mi) {
          if (this.localValue.elle_faiz_mi && this.localValue.takip_sonrasi_faiz_turu) {
            const faizTuruId = await this.$helper.saveFaizTuru(this.localValue.takip_sonrasi_faiz_turu, this.$route.params.id);
            this.localValue.takip_oncesi_faiz_turu_id = faizTuruId;
            this.localValue.takip_sonrasi_faiz_turu_id = faizTuruId;
          } else {
            this.localValue.takip_oncesi_faiz_turu_id = await this.$helper.saveFaizTuru(this.localValue.takip_oncesi_faiz_turu, this.$route.params.id);
            this.localValue.takip_sonrasi_faiz_turu_id = this.localValue.takip_oncesi_faiz_turu_id;
          }
        }
        await this.$http.put('/api/v1/alacak-kalemi/' + this.localValue.id,this.localValue);
        this.$emit("addAsilAlacak",this.localValue);
        this.$emit("onSuccess");
      }else{
        await this.$http.post('/api/v1/alacak/' + this.alacak.id + '/alacak-kalemi',this.localValue);
        this.$emit("addAsilAlacak",this.localValue);
        this.$emit("onSuccess");
      }
    }else{
      this.$emit("addAsilAlacak",this.localValue);
      this.$emit("onSuccess");
    }
  }

  get tarih() {
    if (this.localValue.vade_tarihi) {
      return this.localValue.vade_tarihi;
    } else if (this.localValue.ibraz_tarihi) {
      return this.localValue.ibraz_tarihi;
    }
  }

  get isHideButtons() {
    return this.hideButtons || this.hideButtons === "";
  }

  get aciklama() {
    if (this.localValue.alacak_kalemi_turu && this.alacak.tanzim_tarihi && this.localValue.para_birimi_id) {
      let sozlesmeTarihi = this.$helper.tarihStr(this.alacak.tanzim_tarihi);
      if (this.localValue.alacak_kalemi_turu.id == AlacakKalemiTuru.cezaiSart) {
        return sozlesmeTarihi + " tarihli sözleşmeden kaynaklı cezai şart alacağı"
      } else if (this.localValue.alacak_kalemi_turu.id == AlacakKalemiTuru.cariHesapAlacagi) {
        return sozlesmeTarihi + " tarihli satış sözleşmesinden kaynaklı cari hesap alacağı"
      }
    }
  }

  get dateRule() {
    if (!this.localValue.vade_tarihi) {
      return true; // Allow empty values (handle required validation separately)
    }

    if (new Date(this.alacak.tanzim_tarihi).getTime() <= new Date(this.localValue.vade_tarihi).getTime()) {
      return true;
    } else {
      return 'Tanzim Tarihinden daha önce bir vade tarihi girilemez.';
    }
  }

  get minDate() {
    if (this.alacak.tanzim_tarihi)
      return this.alacak.tanzim_tarihi;
    else
      return null;
  }

  get alacakKalemiRules() {
    if (this.localValue.aciklama) {
      if (this.localValue.aciklama.match(/["'<>&]/g) == null)
        return true;
      else
        return `Yasak karakter. ", ', <, >, & karakterleri kullanılamaz.`;
    } else
      return true;
  }

  private updateParaBirimiState() {
    const paraBirimiId = this.alacak.para_birimi_id;
    const dovizKurTarihi = this.alacak.doviz_kur_tarihi;
    const isForeignCurrency = paraBirimiId !== this.paraBirimi.TRY;
    this.readonlyParaBirimi = false;
    if (!isForeignCurrency) {
      this.localValue.para_birimi_id = this.paraBirimi.TRY;
      return;
    }
    switch (dovizKurTarihi) {
      case DovizTakipSekli.tahsilat:
        this.readonlyParaBirimi = true;
        this.localValue.para_birimi_id = paraBirimiId;
        break;
      case DovizTakipSekli.vade:
      case DovizTakipSekli.takip:
        this.readonlyParaBirimi = true;
        this.localValue.para_birimi_id = paraBirimiId;
        break;
    }
  }

  @Watch('alacak.para_birimi_id')
  onAlacakParaBirimiChange() {
    this.updateParaBirimiState();
  }

  @Watch('alacak.doviz_kur_tarihi')
  onAlacakDovizKurTarihiChange() {
    this.updateParaBirimiState();
    this.input();
  }

  @Watch("tarih")
  onVadeTarihiChange() {
    this.localValue.faiz_baslangic_tarihi = this.tarih;
  }

  @Watch("aciklama")
  onAciklamaChange() {
    this.localValue.aciklama = this.aciklama;
    this.input();
  }

  mounted() {
    this.updateParaBirimiState();
  }


}
